__turbopack_context__.v({
  "attributesContainer": "w8p8SW_attributesContainer",
  "hideMobile": "w8p8SW_hideMobile",
  "scrollableItemRow": "w8p8SW_scrollableItemRow",
  "scrollableItemRowVariant": "w8p8SW_scrollableItemRowVariant",
  "similarItemsSashWrapper": "w8p8SW_similarItemsSashWrapper",
});
